import React, { useState, useEffect, useRef } from "react";
import "./Home.css";
// Import images and videos from StaticPages
import biomelogo from "../../Assets/photo/biomelogo.png";
import mooks from "../../Assets/photo/mooks.png";
import djk from "../../Assets/video/djk.MP4";
import pink from "../../Assets/photo/pink.png";
import zerm from "../../Assets/photo/zerm.png";
import gamingexhibitionist from "../../Assets/video/gamingexhibitionist.mp4";
// import youtubeVideo from '../../Assets/photo/youtube.mp4';
import audio123 from "../../Assets/photo/123.png";
import audiopill from "../../Assets/video/audiopill.MP4";
import link from "../../Assets/photo/link.png";
import share from "../../Assets/photo/share.png";
import copy from "../../Assets/photo/copy.png";
import maps from "../../Assets/photo/maps (2).png";
import mapslogo from "../../Assets/photo/mapslogo.png";
import youtube from "../../Assets/photo/youtube.png";
// import pixelpanels from '../../Assets/video/pixelpanels.mp4';
import panel169 from "../../Assets/photo/panel169.png";
import gmail from "../../Assets/photo/gmail.png";
// Additional assets for preview, migration and addons sections
// import exhibitionnum2 from '../../Assets/video/exhibitionnum2.mp4';
// import exhibitionnum3 from '../../Assets/video/exhibitionnum3.mp4';
import codeshowcase from "../../Assets/photo/codeshowcase.png";
import bluetick from "../../Assets/photo/bluetick.png";
import calender from "../../Assets/photo/calender.png";
import privacyIcon from "../../Assets/photo/private.png";
import analytic from "../../Assets/photo/analytic.png";
import paynow from "../../Assets/photo/paynow (2).png";
import visa from "../../Assets/photo/visa.png";
import mastercard from "../../Assets/photo/mastercard.png";
import apple from "../../Assets/photo/apple.png";
import poster from "../../Assets/photo/poster.png";
import cloud from "../../Assets/photo/cloud.png";
import hype from "../../Assets/video/hype.mp4";
import queue from "../../Assets/photo/queue.png";

const Home = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  // Close mobile menu
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Handle mobile menu button
  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Handle mute toggle
  const handleMuteToggle = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  // Handle username button
  const handleUsernameClick = (e) => {
    e.preventDefault();
    const migrationSection = document.getElementById("migration");
    if (migrationSection) {
      migrationSection.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.location.href = "#migration";
    }
  };

  // Intersection observer for reveal animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    document.querySelectorAll(".reveal").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  // Phone carousel rotation with PhoneCarousel class
  useEffect(() => {
    class PhoneCarousel {
      constructor() {
        this.carousel = document.getElementById("phoneCarousel");
        if (!this.carousel) return;

        this.phones = Array.from(this.carousel.children);
        this.currentIndex = 0;
        this.isAnimating = false;
        this.animationDuration = 800; // ms
        this.pauseDuration = 3000; // ms
        this.intervalId = null;

        this.init();
        this.startAutoRotation();
      }

      init() {
        // Set initial positions
        this.updatePhonePositions();
      }

      updatePhonePositions() {
        const scaleFactors = [0.7, 0.85, 1, 0.85, 0.7];
        const opacities = [0.4, 0.6, 1, 0.6, 0.4];
        const zIndexes = [1, 2, 5, 2, 1];
        const translateValues = [-120, -60, 0, 60, 120]; // Percentage values

        this.phones.forEach((phone, index) => {
          const adjustedIndex =
            (index - this.currentIndex + this.phones.length) %
            this.phones.length;

          const translateX = translateValues[adjustedIndex];
          const scale = scaleFactors[adjustedIndex];
          const opacity = opacities[adjustedIndex];
          const zIndex = zIndexes[adjustedIndex];

          phone.style.transform = `translateX(${translateX}%) scale(${scale})`;
          phone.style.opacity = opacity;
          phone.style.zIndex = zIndex;
          phone.style.transition = `all ${this.animationDuration}ms ease-in-out`;
        });
      }

      rotateNext() {
        if (this.isAnimating) return;

        this.isAnimating = true;
        this.currentIndex = (this.currentIndex + 1) % this.phones.length;
        this.updatePhonePositions();

        setTimeout(() => {
          this.isAnimating = false;
        }, this.animationDuration);
      }

      startAutoRotation() {
        this.intervalId = setInterval(() => {
          this.rotateNext();
        }, this.pauseDuration + this.animationDuration);
      }

      destroy() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
      }
    }

    const carousel = new PhoneCarousel();

    return () => {
      carousel.destroy();
    };
  }, []);

  // Sticky CTA button sound
  useEffect(() => {
    const stickyButtons = document.querySelectorAll(".sticky-btn");
    stickyButtons.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        const barsContainer = document.createElement("div");
        barsContainer.classList.add("audio-bars");

        for (let i = 0; i < 40; i++) {
          barsContainer?.appendChild(document.createElement("span"));
        }
        this.appendChild(barsContainer);

        const bars = barsContainer.querySelectorAll("span");
        const audio = new Audio("click-snippet.mp3");
        audio.volume = 0.8;
        audio.play().catch((err) => {
          console.warn("Autoplay blocked:", err);
        });

        const barInterval = setInterval(() => {
          bars.forEach((bar) => {
            const scale = Math.random() * 1.6 + 0.4;
            bar.style.transform = `scaleY(${scale})`;
            bar.style.opacity = 0.5 + Math.random() * 0.5;
          });
        }, 180);

        setTimeout(() => {
          clearInterval(barInterval);
          audio.pause();
          window.location.href = this.getAttribute("href");
        }, 3000);
      });
    });
  }, []);

  // FAQ Toggle functionality
  useEffect(() => {
    const faqButtons = document.querySelectorAll(".qa .q");
    faqButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const qaElement = btn.parentElement;
        const isOpen = qaElement.classList.toggle("open");
        btn.querySelector("span").textContent = isOpen ? "–" : "+";
      });
    });
  }, []);

  // Addon panel expand/collapse
  useEffect(() => {
    const addonPanels = document.querySelectorAll(".addon-panel");
    addonPanels.forEach((panel) => {
      const expandBtn = panel.querySelector(".expand-btn");

      if (expandBtn) {
        expandBtn.addEventListener("click", (e) => {
          e.stopPropagation();

          // Close other open panels
          addonPanels.forEach((otherPanel) => {
            if (otherPanel !== panel && otherPanel.classList.contains("open")) {
              otherPanel.classList.remove("open");
            }
          });

          // Toggle current panel
          panel.classList.toggle("open");
        });
      }
    });

    // Close panel when clicking outside
    const closeOnClickOutside = () => {
      addonPanels.forEach((panel) => {
        if (panel.classList.contains("open")) {
          panel.classList.remove("open");
        }
      });
    };

    document.addEventListener("click", closeOnClickOutside);
    return () => document.removeEventListener("click", closeOnClickOutside);
  }, []);

  return (
    <div className="home-container">
      {/* HEADER */}
      <header className="header">
        <div className="container head-nav">
          <div className="brand">
            <a href="/" className="logo-link">
              <img src={biomelogo} alt="BioME Logo" />
            </a>
          </div>
          <nav className="nav-desktop">
            <a href="#features">Brief Features</a>
            <a href="/page/allfeatures">See All Features</a>
            <a href="/page/news">News</a>
            <a href="#pricing">Pricing</a>
            <a href="#addons">Shop</a>
            <a href="/page/news">Contact Us</a>
            <a className="home-btn cta-nav" href="/auth/signup">
              Create
            </a>
          </nav>
          <a href="/auth/login" className="home-btn white admin-header-btn">
            Log In
          </a>
          <button className="mobile-menu-btn" onClick={handleMobileMenuToggle}>
            ☰
          </button>
        </div>
      </header>

      {/* LED CONVEYOR BELT */}
      <div className="led-belt">
        <div className="led-content">
          <span className="led-pixel purple">🚀 Launch Special</span>
          <span className="led-pixel white">
            FULL ACCESS FREE with code "IWBIOME4FR"
          </span>
          <span className="led-pixel warning">
            Special Offer: ⚠️ 30% OFF ⚠️
          </span>
          <span className="led-pixel blue">Music🎵 Cinema🎬</span>
          <span className="led-pixel purple">Express🍀 Play🏀</span>
          <span className="led-pixel white">
            FULL ACCESS FREE with code "IWBIOME4FR"
          </span>
          <span className="led-pixel warning">Create🎨 Engage❤️</span>
          <span className="led-pixel blue">Spotlight🔦 Share🔗</span>
          <span className="led-pixel purple">🚀 Launch Special</span>
          <span className="led-pixel white">
            FULL ACCESS FREE with code "IWBIOME4FR"
          </span>
          <span className="led-pixel warning">ALL ACCESS: ⚠️ 30% OFF ⚠️</span>
          <span className="led-pixel blue">What will you showcase?💫</span>
        </div>
      </div>

      {/* MOBILE MENU */}
      <div
        className={`mobile-menu ${mobileMenuOpen ? "active" : ""}`}
        id="mobileMenu"
      >
        <button className="close-btn" onClick={closeMobileMenu}>
          ×
        </button>
        <div className="mobile-nav">
          <a href="#features" onClick={closeMobileMenu}>
            Brief Features
          </a>
          <a href="/page/allfeatures" onClick={closeMobileMenu}>
            See All Features
          </a>
          <a href="/page/news" onClick={closeMobileMenu}>
            News
          </a>
          <a href="#pricing" onClick={closeMobileMenu}>
            Pricing
          </a>
          <a href="#faq" onClick={closeMobileMenu}>
            FAQ
          </a>
          <a href="/page/news" onClick={closeMobileMenu}>
            Contact Us
          </a>
          <a
            href="/auth/signup"
            onClick={closeMobileMenu}
            className="mobile-cta"
          >
            Create My BioME
          </a>
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-content">
            <h1 className="reveal">
              BioME | The Multi-Sensorial Page-in-bio, For creators & founders
            </h1>
            <p className="reveal" style={{ transitionDelay: "0.06s" }}>
              Everyone can now be the creator they imagined! Redefining the
              LinkInBio Industry with BioME
            </p>
            <div
              className="actions reveal"
              style={{ transitionDelay: "0.12s" }}
            >
              <div className="username-claim-pill">
                <span className="pill-text">Get into your biomeee.com/</span>
                <div className="username-container">
                  <button
                    className="username-btn"
                    id="usernameBtn"
                    onClick={handleUsernameClick}
                  >
                    Sign Up
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="phone-carousel-section reveal">
            <div className="phone-carousel-container">
              <div className="phone-carousel" id="phoneCarousel">
                <div className="phone" data-index="4">
                  <div className="island"></div>
                  <div className="screen">
                    <img src={mooks} alt="Screen image" />
                  </div>
                </div>
                <div className="phone" data-index="0">
                  <div className="island"></div>
                  <div className="screen">
                    <video autoPlay loop muted playsInline>
                      <source src={djk} type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div className="phone" data-index="4">
                  <div className="island"></div>
                  <div className="screen">
                    <img src={pink} alt="Screen image" />
                  </div>
                </div>
                <div className="phone" data-index="4">
                  <div className="island"></div>
                  <div className="screen">
                    <img src={zerm} alt="Screen image" />
                  </div>
                </div>
                <div className="phone" data-index="3">
                  <div className="island"></div>
                  <div className="screen">
                    <video autoPlay loop muted playsInline>
                      <source src={gamingexhibitionist} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
            <div className="phone-disclaimer reveal">
              These are fan-made inspirations
            </div>
          </div>
        </div>
      </section>

      {/* FULL-BLEED VIDEO */}
      <section className="video-player-section">
        <div className="video-container">
          {/* <video autoPlay loop muted playsInline id="mainVideo" ref={videoRef}>
            <source src={youtubeVideo} type="video/mp4" />
          </video> */}
          <div
            className="mute-toggle"
            id="muteToggle"
            onClick={handleMuteToggle}
          >
            <svg viewBox="0 0 24 24" id="muteIcon">
              <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
            </svg>
          </div>
        </div>
      </section>

      {/* FEATURES GRID */}
      <section id="features" className="apple-grid">
        <div className="container">
          <h2>Everything you know and more!</h2>

          <div className="grid-wwdc">
            {/* Feature 1: Audio Attachment */}
            <div className="tile span-7 reveal">
              <div className="inner feature-content">
                <div className="feature-text">
                  <img src={audio123} alt="Audio" className="feature-icon" />
                  <h3>Audio Attachment for Music & Annoucements</h3>
                  <p>
                    Speak, sell, promote, announce, chat and engage all your
                    visitors.
                  </p>
                </div>
                <div className="feature-media">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{ width: "100%" }}
                  >
                    <source src={audiopill} type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>

            {/* Feature 2: Designer Links */}
            <div className="tile span-5 reveal">
              <div className="inner feature-center">
                <img
                  src={link}
                  alt="Unlimited Designer Links"
                  className="feature-image"
                />
                <h3 className="text-center">Unlimited Designer Links</h3>
                <p className="text-center">
                  Display all of your tappable links and personalize them to
                  your liking, extensive customizations allow for pixel-perfect
                  vibe and mood.
                </p>
              </div>
            </div>

            {/* Feature 3: Shareable QR Code */}
            <div className="tile span-5 reveal">
              <div className="inner feature-content-flex">
                <div className="feature-media">
                  <img src={share} alt="Analytics Dashboard" />
                </div>
                <div className="feature-text">
                  <img src={copy} alt="QR Code" className="feature-icon" />
                  <h3>Shareable QR Code📱</h3>
                  <p>
                    Lead on-site people directly to your BioME page hassle-free
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 4: Maps */}
            <div className="tile span-7 reveal">
              <div className="inner feature-content">
                <div className="feature-media">
                  <img src={maps} alt="Maps" />
                </div>
                <div className="feature-text">
                  <img
                    src={mapslogo}
                    alt="Maps Logo"
                    className="feature-icon"
                  />
                  <h3>
                    Embed Map Location
                    <br />
                    [Direct to G.Maps]
                  </h3>
                  <p>
                    Showcase your location, direct natural audiences to your
                    business or events with seamless Google Maps intergration.
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 5: YouTube Embeds */}
            <div className="tile span-4 reveal">
              <div className="inner feature-center">
                <img
                  src={youtube}
                  alt="YouTube Embeds"
                  className="feature-image"
                />
                <h3 className="text-center">Youtube Embeds</h3>
                <p className="text-center">
                  Seamless Youtube in-app integration.
                </p>
              </div>
            </div>

            {/* Feature 6: Pixel Panels */}
            <div className="tile span-4 reveal">
              <div className="inner feature-content-flex">
                <div className="feature-media">
                  {/* <video autoPlay loop muted playsInline>
                    <source src={pixelpanels} type="video/mp4" />
                  </video> */}
                </div>
                <div className="feature-text">
                  <img
                    src={panel169}
                    alt="Pixel Panels"
                    className="feature-icon"
                  />
                  <h3>Utility Pixel Panels 👾📟</h3>
                  <p>
                    Animate and Appeal your Page with eye catching dynamic
                    panels
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 7: Email Collection */}
            <div className="tile span-4 reveal">
              <div className="inner feature-center">
                <img
                  src={gmail}
                  alt="Email Collection"
                  className="feature-image"
                />
                <h3 className="text-center">Email Collection</h3>
                <p className="text-center">
                  Build your audience with built-in email forms and automated
                  follow-ups.
                </p>
              </div>
            </div>

            {/* Feature 8: Cinematic Play */}
            <div className="tile span-7 reveal">
              <div className="inner feature-content">
                <div className="feature-text">
                  <img
                    src={mapslogo}
                    alt="Maps Logo"
                    className="feature-icon"
                  />
                  <h3>
                    [Cinematic Play] 🎧🌀
                    <br />
                    Capture Attention like Never Before
                  </h3>
                  <p>
                    {" "}
                    Dynamically preview visualised content with audio and create
                    your personal domain to immerse viewers.
                  </p>
                </div>
                <div className="feature-media">
                  <img src={maps} alt="Maps" />
                </div>
              </div>
            </div>

            {/* Feature 9: Pop-Up Campaigns */}
            <div className="tile span-5 reveal">
              <div className="inner feature-center">
                <img
                  src={poster}
                  alt="Unlimited Designer Links"
                  className="feature-image"
                  style={{
                    width: "60%",
                    margin: "0 auto 18px",
                    aspectRatio: "5 / 8",
                    objectFit: "cover",
                    borderRadius: "0px",
                    display: "block",
                  }}
                />
                <h3 className="text-center">💯 Pop-Up Campaigns 📢</h3>
                <p className="text-center">
                  Attached your own Pop-Ups on the front of your page. Driving
                  100% view rate to showcase your posters, campaigns, promotions
                  & clips for everyone that enters your link!
                </p>
              </div>
            </div>

            {/* Feature 10: Cloud-Based Storage */}
            <div className="tile span-5 reveal">
              <div className="inner feature-center mx-auto">
                <div className="feature-media">
                  <img src={cloud} alt="Analytics Dashboard" />
                </div>
                <div className="feature-text">
                  <h3 className="text-center">
                    ☁️ Cloud-Based Storage📤 <br />
                    Manage content anywhere
                  </h3>
                  <p className="text-center">
                    Cross Log In with all your different devices. Change,
                    Update, Transfer or even Save & Upload media anytime
                    anywhere with speed!
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 4: Maps */}
            <div className="tile span-7 reveal">
              <div className="inner feature-content">
                <div
                  style={{ flex: 1, borderRadius: "0px", overflow: "hidden" }}
                >
                  <div style={{ width: "100%", aspectRatio: "3 / 5" }}>
                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                        borderRadius: "0px",
                        pointerEvents: "none",
                      }}
                    >
                      <source src={hype} type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div className="feature-text">
                  <img src={queue} alt="Maps Logo" className="feature-icon" />
                  <h3>
                    🎉🥳 Event Hyping &
                    <br />
                    Stage Countdowns
                  </h3>
                  <p>
                    Showcase your location, direct natural audiences to your
                    business or events with seamless Google Maps intergration.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PREVIEW SECTION */}
      <section id="preview" className="preview">
        <div className="container">
          <h2 className="reveal">Exhibition On The Fly!</h2>
          <div className="phones">
            <div className="phone-preview reveal">
              <div className="island"></div>
              <div className="screen">
                <video autoPlay loop muted playsInline>
                  <source src={gamingexhibitionist} type="video/mp4" />
                </video>
              </div>
            </div>
            <div
              className="phone-preview reveal"
              style={{ animationDelay: "0.05s" }}
            >
              <div className="island"></div>
              <div className="screen">
                {/* <video autoPlay loop muted playsInline>
                  <source src={exhibitionnum2} type="video/mp4" />
                </video> */}
              </div>
            </div>
            <div
              className="phone-preview reveal"
              style={{ animationDelay: "0.1s" }}
            >
              <div className="island"></div>
              <div className="screen">
                {/* <video autoPlay loop muted playsInline>
                  <source src={exhibitionnum3} type="video/mp4" />
                </video> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="pricing" className="pricing">
        <div className="container">
          <h2 className="reveal">
            Unlock features that match your vision!
            <br />
            (Beta Price)
          </h2>
          <div className="tiers">
            <div className="tier reveal">
              <div className="pill">FREE</div>
              <h4>My 1st BioME!</h4>
              <div className="price">$0</div>
              <ul className="features-list">
                <li>Your Own Landing Page</li>
                <li>Up to 4 Albums</li>
                <li>Basic Analytics</li>
                <li>Audio CTA 🔊🎧</li>
                <li>Starter Engagement UI Pack</li>
                <li>Capped Showcasing Space</li>
              </ul>
            </div>
            <div className="tier reveal" style={{ transitionDelay: "0.06s" }}>
              <div className="pill">Monthly | Beta Price🔥</div>
              <h4>BioMExplorer</h4>
              <div className="price">
                $6.5
                <span style={{ fontSize: "16px", fontWeight: "600" }}>/mo</span>
              </div>
              <ul className="features-list">
                <li>Everything in Free</li>
                <li>Unlimited Albums</li>
                <li>5GB Expandable Storage</li>
                <li>More Beautiful Features</li>
                <li>Unlock Cinematic Play 🎬</li>
                <li>Custom Wallpapers, Maps, Reformat Grids & more</li>
              </ul>
            </div>
            <div
              className="tier pop reveal"
              style={{ transitionDelay: "0.12s" }}
            >
              <div className="pill">Annual | Free 2mths</div>
              <h4>The BioME Experience</h4>
              <div className="price">
                $65
                <span style={{ fontSize: "16px", fontWeight: "600" }}>/yr</span>
              </div>
              <ul className="features-list">
                <li>Everything in Monthly</li>
                <li>Boosted 10min Audios</li>
                <li>Full Range of UI Perks/Features</li>
                <li>Creator Profile Pop up Campaigns 🎯📈</li>
                <li>Appear in viewers notifications for releases</li>
                <li>Early access & validation of new features!🌟</li>
              </ul>
            </div>
          </div>
          <p
            style={{
              textAlign: "center",
              marginTop: "10px",
              fontFamily: "'Archivo Black', sans-serif",
              fontSize: "16px",
            }}
          >
            <a
              href="/page/allfeatures"
              style={{ color: "#fff", textDecoration: "underline" }}
            >
              See All Features →
            </a>
          </p>
        </div>
      </section>

      {/* MIGRATION SECTION */}
      <section id="migration" className="migration-section reveal">
        <div className="container">
          <h2>🚀 1 Mnth of Annual Plan on us! 💎</h2>
          <div className="migration-content">
            <div className="migration-text">
              <h3>
                IWBIOME4FR
                <br />
              </h3>
              <ul className="migration-bullets">
                <li>
                  <strong>Got a Fan Base?</strong>
                  <br />
                  <br />- Generate your own referral code (eg. Alex123){" "}
                  <a
                    href="#addons"
                    style={{
                      textDecoration: "underline",
                      color: "#0026F9",
                      fontWeight: "600",
                    }}
                  >
                    here
                  </a>{" "}
                  , post 2 videos of you sharing your code & send both video
                  links to us via{" "}
                  <a
                    href="#addons"
                    style={{
                      textDecoration: "underline",
                      color: "#A020F0",
                      fontWeight: "600",
                    }}
                  >
                    here
                  </a>{" "}
                  and attain a free{" "}
                  <a
                    href="#addons"
                    style={{
                      textDecoration: "underline",
                      color: "#0026F9",
                      fontWeight: "600",
                    }}
                  >
                    verified badge
                  </a>{" "}
                  (worth $2/mth) on your BioME page!
                  <br />
                  <br />
                  <a
                    href="#addons"
                    style={{
                      textDecoration: "underline",
                      color: "#A020F0",
                      fontWeight: "100",
                    }}
                  >
                    refcode_tnc
                  </a>{" "}
                  🎲
                  <a
                    href="#addons"
                    style={{
                      textDecoration: "underline",
                      color: "#A020F0",
                      fontWeight: "100",
                    }}
                  >
                    apply badge here
                  </a>
                </li>
              </ul>
              <div className="migration-cta">
                <a href="/auth/signup" className="btn1">
                  GET STARTED WITH CODE NOW
                </a>
              </div>
            </div>
            <div className="migration-image">
              <img src={codeshowcase} alt="BioME Migration Interface" />
            </div>
          </div>
        </div>
      </section>

      {/* ADDONS SECTION */}
      <section id="addons" className="addons-section">
        <section className="addons-dramatic reveal">
          <div className="addons-header">
            <h2>🛍️ BioME Shop (Coming Soon)</h2>
            <p>
              <b>
                Purchase creator advancements and page enhacements with one-time
                payments and subscriptions
              </b>
            </p>
          </div>

          {/* Payment Methods Section */}
          <div className="payment-methods">
            <p>We Accept</p>
            <div className="payment-logos">
              <div className="payment-logo">
                <img src={paynow} alt="PayNow" />
              </div>
              <div className="payment-logo">
                <img src={visa} alt="Visa" />
              </div>
              <div className="payment-logo">
                <img src={mastercard} alt="Mastercard" />
              </div>
              <div className="payment-logo">
                <img src={apple} alt="Apple Pay" />
              </div>
            </div>
          </div>

          <div className="addons-panels">
            {/* Panel 1 - Blue Tick */}
            <div className="addon-panel panel1">
              <img
                className="panel-video"
                src={bluetick}
                alt="Blue Tick Addon"
              />
              <div className="expand-btn">
                <svg viewBox="0 0 24 24">
                  <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                </svg>
              </div>
              <div className="panel-details">
                <h3>Blue Tick - $14.90 One-Time</h3>
                <p>
                  Up your page with a blue tick badge
                  <br />
                  <br />
                  <br />
                </p>
              </div>
            </div>

            {/* Panel 2 - Booking Calendar */}
            <div className="addon-panel panel2">
              <img
                className="panel-video"
                src={calender}
                alt="Booking Calendar Addon"
              />
              <div className="expand-btn">
                <svg viewBox="0 0 24 24">
                  <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                </svg>
              </div>
              <div className="panel-details">
                <h3>Booking Calender $5/mo</h3>
                <p>
                  Let prospects and customers book you with in-built calender
                  synced to your Google Calender
                  <br />
                  <br />
                  <br />
                </p>
              </div>
            </div>

            {/* Panel 3 - Privacy */}
            <div className="addon-panel panel3">
              <img
                className="panel-video"
                src={privacyIcon}
                alt="Censorship Verification Addon"
              />
              <div className="expand-btn">
                <svg viewBox="0 0 24 24">
                  <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                </svg>
              </div>
              <div className="panel-details">
                <h3>Censorship Verification $5/mo</h3>
                <p>
                  Adhere to{" "}
                  <a
                    href="/page/censorcompliance"
                    style={{
                      textDecoration: "underline",
                      color: "#7a0bc0",
                      fontWeight: "600",
                    }}
                  >
                    community guidelines
                  </a>{" "}
                  when posting private content; guard links, images, audios and
                  even entire access to your BioME page with age, password or
                  pin.
                  <br />
                  <br />
                  <br />
                </p>
              </div>
            </div>

            {/* Panel 4 - Analytics */}
            <div className="addon-panel panel4">
              <img
                className="panel-video"
                src={analytic}
                alt="Higher Analytics Addon"
              />
              <div className="expand-btn">
                <svg viewBox="0 0 24 24">
                  <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                </svg>
              </div>
              <div className="panel-details">
                <h3>Higher Analytics $3/mo</h3>
                <p>
                  Unlock advanced UTC parameters and deeper insights on
                  viewership, user screen time and behaviour.
                  <br />
                  <br />
                  <br />
                </p>
              </div>
            </div>
          </div>

          {/* "See All Features" link */}
          <div className="addons-cta">
            <a href="#faq" className="shop-cta-link">
              Full Shop Coming Soon →
            </a>
          </div>
        </section>
      </section>

      {/* FAQ SECTION */}
      <section id="faq" className="faq">
        <div className="container faq-wrap">
          <h2 className="reveal">FAQ</h2>

          <div className="qa reveal">
            <button className="q">
              Is the free version really free? <span>+</span>
            </button>
            <div className="a">
              <br />
              Yes, your 1st BioME is free forever and already comes with teasers
              and many features from the Explorer Plans
            </div>
          </div>

          <div className="qa reveal">
            <button className="q">
              How does the audio player work?🎵🔊 <span>+</span>
            </button>
            <div className="a">
              <br />
              Simply upload a video with sound from your device, it will extract
              the audio from the video and use it in the player!
            </div>
          </div>

          <div className="qa reveal">
            <button className="q">
              How do I update my BioME? <span>+</span>
            </button>
            <div className="a">
              <br />
              Edit your BioME page in your dashboard on any logged in device,
              changes go live instantly.
            </div>
          </div>

          <div className="qa reveal">
            <button className="q">
              Can I showcase videos, images, files, and audio? <span>+</span>
            </button>
            <div className="a">
              <br />
              Absolutely. Moreover, everyone gets to try BioME's best plan on
              the house for the first month first.
              <br />
              <br />
              Every account its own dedicated mini cloud space, Upload in your
              page as any format and access it from any device in the world!
              Upload memories, menus, blogs and share it with everyone.
            </div>
          </div>

          <div className="qa reveal">
            <button className="q">
              Who is it for and how can i share my BioME <span>+</span>
            </button>
            <div className="a">
              BioME is for individuals, edit fanatics, fanpages, memory albums,
              small businesses, content creators, bloggers
              <br />
              <br />
              Share and express indvidualistically under one awesome link that
              connects audience to creator engagingly
            </div>
          </div>

          <div className="qa reveal">
            <button className="q">
              Is PayNow accepted as a payment method? 💳 <span>+</span>
            </button>
            <div className="a">
              <br />
              Paynow is accepted for our One-Time purchase add ons accesories,
              subscription plans only accept Visa, Mastercard & Apple Pay for
              now.
            </div>
          </div>

          <div className="qa reveal">
            <button className="q">
              How is my media safely stored. 📁 <span>+</span>
            </button>
            <div className="a">
              <br />
              Images, Videos and Audios in the formats uploaded in BioME are
              stored in your dedicated cloud space and can be retreived,
              downloaded and managed in the Library Tab
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container foot">
          <img src={biomelogo} alt="BioME" />
          <div
            style={{
              display: "flex",
              gap: "18px",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <a
              href="https://www.instagram.com/biome_com?igsh=MnJjdGljNmFiOHF6"
              style={{ textDecoration: "none" }}
            >
              IG
            </a>
            <a
              href="https://s.lemon8-app.com/s/GgbYRdpmZw"
              style={{ textDecoration: "none" }}
            >
              Lemon8
            </a>
            <a
              href="https://www.tiktok.com/@biome.co?_r=1&_t=ZS-92pujLwlsA8"
              style={{ textDecoration: "none" }}
            >
              Tiktok
            </a>
            <a
              href="https://t.me/biomenewsupdates"
              style={{ textDecoration: "none" }}
            >
              Telegram
            </a>
            <a href="/page/news" style={{ textDecoration: "none" }}>
              Contact
            </a>
          </div>
          <small>
            © {new Date().getFullYear()} BioME.com. All rights reserved.
          </small>
        </div>
      </footer>

      {/* STICKY CTA */}
      <div className="sticky-cta">
        <a href="/auth/signup" className="home-btn sticky-btn">
          Create Your BioME ✨
        </a>
      </div>
    </div>
  );
};

export default Home;
